import { Utils } from 'utils/Utils'
import Device from './Device'

export const otoscope: Device = {
  name: 'Otoscope',
  value: 'otoscope',
  nameToDisplay: 'Otoscope',
  examination: true,
  types: ['Ear Right', 'Ear Left', 'Throat', 'Skin'],
  kind: 'device',
  ignoreForDoctor: false,
}

export const dermatoscope: Device = {
  name: 'Dermatoscope',
  value: 'dermatoscope',
  nameToDisplay: 'Digital scope',
  examination: true,
  types: ['Ears', 'Throat', 'Skin'],
  kind: 'device',
  ignoreForDoctor: false,
}

export const ophthalmoscope: Device = {
  name: 'Ophthalmoscope',
  value: 'ophthalmoscope',
  nameToDisplay: 'Ophthalmoscope',
  examination: true,
  types: ['Right Eye', 'Left Eye'],
  kind: 'device',
  ignoreForDoctor: false,
}
export const glucometer: Device = {
  name: 'Glucometer',
  value: 'glucometer',
  nameToDisplay: 'Glucometer',
  examination: true,
  types: ['Blood glucose'],
  kind: 'device',
  ignoreForDoctor: true,
}

export const edanEcg: Device = {
  name: 'Edan-ECG',
  value: 'edan-ecg',
  nameToDisplay: 'ECG',
  examination: true,
  types: ['ECG'],
  kind: 'device',
  ignoreForDoctor: false,
}

export const edanVitals: Device = {
  name: 'Edan-Vitals',
  value: 'edan-vitals',
  nameToDisplay: 'Vitals',
  examination: true,
  types: ['Vitals'],
  kind: 'device',
  ignoreForDoctor: true,
}

export const scale: Device = {
  name: 'Scale',
  value: 'scale',
  nameToDisplay: 'Scale',
  examination: true,
  types: ['Weight'],
  kind: 'device',
  ignoreForDoctor: false,
}

export const eko: Device = {
  name: 'Eko',
  value: 'eko',
  nameToDisplay: 'Eko',
  examination: true,
  types: ['Lungs', 'Heart'],
  kind: 'device',
  ignoreForDoctor: false,
}

export const levEl: Device = {
  name: 'Lev-El',
  value: 'lev-el',
  nameToDisplay: 'Lev-El',
  examination: true,
  types: ['Lev-El'],
  kind: 'device',
  ignoreForDoctor: false,
}

export const heartTrends: Device = {
  name: 'Heart-Trends',
  value: 'heart-trends',
  nameToDisplay: 'Heart-Trends',
  examination: true,
  types: ['Stress'],
  kind: 'device',
  ignoreForDoctor: false,
}

export const deviceOrder: Device = {
  name: 'Order',
  value: 'order',
  nameToDisplay: 'Order',
  examination: true,
  types: ['Order'],
  kind: 'order',
  ignoreForDoctor: false,
}

export const oxitone: Device = {
  name: 'Oxitone',
  value: 'oxitone',
  nameToDisplay: 'Oxitone',
  examination: false,
  types: ['Continous vitals'],
  kind: 'device',
  ignoreForDoctor: false,
}

export const ultrasound: Device = {
  name: 'Ultrasound',
  value: 'ultrasound',
  nameToDisplay: 'Ultrasound',
  examination: true,
  types: [
    'Ascites',
    'Bladder',
    'Pulmonary edema',
    'Lung base',
    'Assessment of tendons',
    'Muscles and joints',
    'Soft tissue',
    'Whole body imaging for fast',
    'Whole body imaging for tear and fracture assessment',
    'DVT',
  ],
  kind: 'device',
  ignoreForDoctor: false,
}

export const bloodChemistry: Device = {
  name: 'Blood-Chemistry',
  value: 'blood-chemistry',
  nameToDisplay: 'Blood-Chemistry',
  examination: true,
  types: ['picolo'],
  bloodTypes: [
    'Comprehensive Metabolic Panel',
    'Lipid Panel Plus',
    'General Chemistry 13',
    'Biochemistry Panel Plus',
  ],
  kind: 'device',
  ignoreForDoctor: false,
}

// PATHFAST cardiac markers. Same tube-QR lab flow as bloodChemistry (the medtech
// scans the tube, results arrive later over ASTM and are drained in), but each
// assay is its own cartridge rather than a fixed reagent-disc panel — the
// analyzer runs up to 6 at once — so bloodTypes lists individual assays.
export const cardiacMarkers: Device = {
  name: 'Cardiac-Markers',
  value: 'cardiac-markers',
  nameToDisplay: 'Cardiac Markers',
  examination: true,
  types: ['pathfast'],
  bloodTypes: ['hs-cTnI', 'NT-proBNP', 'D-Dimer'],
  kind: 'device',
  ignoreForDoctor: false,
}

export const bloodHematology: Device = {
  name: 'Blood-Hematology',
  value: 'blood-hematology',
  nameToDisplay: 'Blood-Hematology',
  examination: true,
  types: ['Blood-Hematology'],
  kind: 'device',
  ignoreForDoctor: false,
}

export const urine: Device = {
  name: 'Urine',
  value: 'urine',
  nameToDisplay: 'Urine',
  examination: true,
  types: ['Urine'],
  kind: 'device',
  ignoreForDoctor: false,
}

// Rapid antigen cassettes. No device and no lab: the medtech runs the kit at the
// bedside and types the read-off line(s) in. Results are qualitative
// (Detected/Not detected/Invalid) and land in details.result with the same
// [{type, units, value}] shape the CBC form writes, so the labs table needs no
// new payload branch. The answer list itself lives with the entry form
// (medioraapp react/utils/rapidTests.ts) — the EHR only ever renders the value.
export const rapidStrepA: Device = {
  name: 'Rapid-Strep-A',
  value: 'rapid-strep-a',
  nameToDisplay: 'Strep A rapid test',
  examination: true,
  types: ['Strep A'],
  kind: 'device',
  ignoreForDoctor: false,
}

// One kit, three answers (SARS-CoV-2 / Influenza A / Influenza B) — modelled as
// one exam with three result rows rather than the Blood-Chemistry bloodTypes
// fan-out, because the analytes are fixed by the cassette.
export const rapidCovidFlu: Device = {
  name: 'Rapid-Covid-Flu',
  value: 'rapid-covid-flu',
  nameToDisplay: 'COVID-19 + Influenza A/B rapid test',
  examination: true,
  types: ['COVID-19 + Influenza A/B'],
  kind: 'device',
  ignoreForDoctor: false,
}

// The provider can still order COVID-19 alone, Influenza alone, or both. The
// tablet runs the full kit whichever was chosen, and the provider and PCC get
// all three results; the choice is kept on the order as details.orderedTests
// (ehr-server getExamDocument) and only decides what is reported for billing.
export enum RapidCovidFluOrderedTest {
  covid = 'COVID-19',
  influenza = 'Influenza',
}

export const rapidCovidFluOrderOptions: Array<{
  label: string
  orderedTests: RapidCovidFluOrderedTest[]
}> = [
  { label: 'COVID-19 rapid test', orderedTests: [RapidCovidFluOrderedTest.covid] },
  { label: 'Influenza A/B rapid test', orderedTests: [RapidCovidFluOrderedTest.influenza] },
  {
    label: 'COVID-19 + Influenza A/B rapid test',
    orderedTests: [RapidCovidFluOrderedTest.covid, RapidCovidFluOrderedTest.influenza],
  },
]

// The label for what was ordered. No orderedTests (orders placed before the
// options existed) means the whole kit.
export const rapidCovidFluOrderLabel = (orderedTests?: string[]): string =>
  rapidCovidFluOrderOptions.find(
    option =>
      option.orderedTests.length === (orderedTests?.length ?? 0) &&
      option.orderedTests.every(test => orderedTests?.includes(test)),
  )?.label ?? rapidCovidFlu.nameToDisplay

export const rapidRsv: Device = {
  name: 'Rapid-RSV',
  value: 'rapid-rsv',
  nameToDisplay: 'RSV rapid test',
  examination: true,
  types: ['RSV'],
  kind: 'device',
  ignoreForDoctor: false,
}

export const rapidTests: Array<Device> = [rapidStrepA, rapidCovidFlu, rapidRsv]

export const rapidTestNames: Array<string> = rapidTests.map(test => test.name)

// Orthostatic vitals. No device to pair with: the medtech is guided through three
// timed positional stages on the tablet (supine 5 min, standing 1 min, standing
// 3 min) and types each blood pressure in. One order, three measurements — the
// stages are inseparable, so they are never ordered individually.
//
// Results land in `details.orthostatic` (see medioraapp react/utils/orthostaticBp.ts)
// rather than the vitals series: a standing pressure that has dropped is the finding
// this test exists to produce, and feeding it to the vitals watch would page STAT on
// a reading that is expected.
export const orthostaticBp: Device = {
  name: 'Orthostatic-BP',
  value: 'orthostatic-bp',
  nameToDisplay: 'Orthostatic Blood Pressure Test',
  examination: true,
  types: ['Orthostatic BP'],
  kind: 'device',
  ignoreForDoctor: false,
}

export const generalLab = {
  name: 'Lab',
}

export const generalExamination = {
  name: 'General',
  type: 'General',
  subCategorys: ['Imaging', 'Laboratory', 'Cardiology', 'Pathology', 'General'],
}

export const Devices: Array<Device> = [
  glucometer,
  edanEcg,
  edanVitals,
  scale,
  eko,
  deviceOrder,
  dermatoscope,
  ultrasound,
  bloodChemistry,
  cardiacMarkers,
  bloodHematology,
  urine,
  ...rapidTests,
  orthostaticBp,
]

export const DevicesForAppointment: Array<Device> = [heartTrends, ...Devices]

export const DevicesMap: Map<string, Device> = Utils.getArrToMap('value', [otoscope, ...Devices])
